
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import _ from 'lodash';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer } from '../../../global/cnr/reducers/SidebarReducer';
import { getGroupListData } from '../../../global/common/sorting';
import { appUserLevels, gEnums } from '../../../global/enums/globalEnums';
import MenuSidebars from '../../../global/sidebars/MenuSidebars';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import GolfLineupSelect from './GolfLineupSelect';
import GolfLineupSimple from './GolfLineupSimple';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

const sidebarType = 'lineups'

const GolfLineup = (props) => {

  const { gmd } = props
  let { displayType } = props

  const { setStyleAndClass } = useStyles()

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { desktopMode, currentSwiperTab } = framework_state ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, fns } = golfParent_contexts ?? {}
  const { paps_state, item_state, golfTournament_state } = states ?? {}

  console.log('golfTournament_state', golfTournament_state)

  const { appUser_fns } = fns ?? {}

  // parentContext  
  const allowMods = appUser_fns.validateAccess_item(appUserLevels.superAdmin, true)

  // papsContext 
  const { pathViews } = paps_state ?? {}

  // sidebar_state 
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInits } = sidebar_handlers ?? {}
  const { ms_lineups } = sidebar_items ?? {}
  const { selected: lineup_selected } = ms_lineups ? ms_lineups : {}
  const { itemKey: lineup_item } = lineup_selected ? lineup_selected : {}

  let { tournamentRounds: roundKey, tournamentTeams: teamKey } = pathViews ?? {}
  if (!roundKey && gmd && gmd.tournamentRounds) { roundKey = gmd.tournamentRounds }

  const isTeamLineups = teamKey ? teamKey : false

  // uiItemContext
  // const uiItemContext = useContext(UiItemContext); 
  const { viewItem } = item_state ?? {}
  const { display, desktopDisplay } = viewItem ?? {}
  const _display = desktopMode && desktopDisplay ? desktopDisplay : display
  let { displaySize } = _display ?? {}

  if (!displayType && displaySize) { displayType = displaySize }
  if (!displayType) { displayType = gEnums.displaySizes.full }

  // golfParentContext 
  const { details } = golfTournament_state ?? {}
  const { lineups, rounds: rounds_tournament, golfers: golfers_tournament } = details ?? {}

  const golfers_team = golfers_tournament ? _.pickBy(golfers_tournament, { teamNumber: parseInt(teamKey) }) : {}

  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.actionButton })

  styleAndClass.style = { backgroundColor: 'var(--sem-blue)' }

  const [round, setRound] = useState()
  const [golferCount, setGolferCount] = useState()
  const [lineupName, setLineupName] = useState()
  const [roundColor, setRoundColor] = useState()
  const [showWizard, setShowWizard] = useState()
  const [sortData, setSortData] = useState()
  const [lineups_team, setTeamLineups] = useState()
  const [golfers_lineup, setGolfersLineup] = useState()

  const handleShowWizard = () => setShowWizard(!showWizard)
  const handleUpdated = () => setShowWizard(!showWizard)

  useEffect(() => {
    if (allowMods) {
      framework_handlers.handleAdd_navigationItem('showLineup', { icon: 'edit', caption: _.startCase('editLineup'), oc: handleShowWizard, activeTabOnly: 'tournamentLineups' });    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }
  }, [currentSwiperTab]);

  // set the teamLineups from the lineups with a filter on tournamentTeamsKey
  useEffect(() => {
    if (teamKey && lineups) {
      const tlups = lineups['team' + teamKey]
      setTeamLineups(tlups)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [lineups]);

  // if we have the teamLineups, create the sidebar with the teamLineup keys
  useEffect(() => {
    if (lineups_team) {
      const tll = []
      Object.keys(lineups_team).forEach(key => {
        tll.push(key)
      })
      const _tll = _.sortBy(tll)
      setInits([
        { smt: sidebarMenuTypes.one, items: _tll, currents, as: 'lineups', useStartCase: true },
      ])
    } else {
      setInits([
        { smt: sidebarMenuTypes.one, items: ['Best Ball', 'Alternate Shot', 'Singles'], currents, as: 'lineups' },
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [lineups_team]);

  // if we have the teamLineups and a lineup_item, get the golfers in the teamLineups
  useEffect(() => {
    if (lineups_team && lineup_item) {
      const lineup_team = lineups_team[lineup_item]  //_.find(lineups_team, { name: lineup_item })
      if (lineup_team) {
        const _golfers_lineup = lineup_team
        const round = lineup_item && rounds_tournament && rounds_tournament[lineup_item] ? rounds_tournament[lineup_item] : {}

        const { roundColor } = round ? round : {}
        let { golfersPerTeam } = round ? round : 2
        golfersPerTeam = 2

        let _sitting = {}
        if (_golfers_lineup && golfers_team) {
          if (Object.keys(_golfers_lineup).length !== Object.keys(golfers_team).length) {
            Object.keys(golfers_team).forEach(key => {
              if (!_golfers_lineup[key]) {
                _sitting[key] = golfers_team[key]
              }
            })
          }
        }

        const sort_data = _golfers_lineup ? getGroupListData(_golfers_lineup, null, golfersPerTeam ? golfersPerTeam : 2, 'group', _sitting) : {}

        setGolfersLineup(_golfers_lineup)
        setSortData(sort_data)
        setLineupName(lineup_item)
        setGolferCount(golfersPerTeam)
        setRoundColor(roundColor)
        setRound(round)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [lineup_item, isTeamLineups, lineups, lineups_team]);

  // const pi = (onClick, iconName, size, styleAndClass, altCn, color) => <PopupIcon piProps={{ onClick, iconName, size, styleAndClass, altCn, color }} />

  const lineupContentWithPopup = () =>
    <React.Fragment>
      {sortData && sortData.groups && <GolfLineupSimple groups={sortData.groups} round={round} items={golfers_lineup} />}
      {/* {allowMods && pi(handleShowWizard, 'edit', 'large', styleAndClass, g_cns.item_popup_solo_left + ' stag')} */}
    </React.Fragment>


  const lineupWizard = () => <GolfLineupSelect
    callbackSave={handleUpdated}
    golferCount={golferCount}
    golfers_lineup={golfers_lineup}
    handleCancel={handleShowWizard}
    lineupName={lineupName}
    round={round}
    roundColor={roundColor}
    teamKey={teamKey}
  />

  const lineup = () => showWizard ? lineupWizard() : lineupContentWithPopup()

  const menuSidebars = () => <MenuSidebars
    sidebarType={sidebarType}
    sidebar_items={sidebar_items}
    sidebar_handlers={sidebar_handlers}
    content={lineup()}
    dimmed={dimmed}
  />

  if (sidebar_items && sortData) {
    return menuSidebars()
  } else {
    return !sortData ? <div></div> : lineup()
  }
}

export default GolfLineup